module.exports = __webpack_public_path__ + "static/media/Boost.2a57cfce.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/SmallTimeline/assets/Boost.svg
// module id = 184
// module chunks = 0